import React, { ReactNode } from "react";
import HivewatchTheme from "./HivewatchTheme";

//
// types
//
export interface EnvironmentConfig {
  devMode: boolean;
  navColor: string;
}

type ImageSrc = string;
export interface ThemeConfig {
  logo: ImageSrc;
  logoSmall: ImageSrc;
  appName: string;
  landingPage: string;
  tosUrl: string;
  supportUrl?: string;
  externalShopUrl?: string;
  /* Enables:
   * - Orderkeys on registration
   * - Subscription duration display and renewal
   * - shop link
   */
  shopFeatures: boolean;
}

type CombinedConfig = EnvironmentConfig & ThemeConfig;

//
// helpers
//
const isDev = () => {
  return window.location.origin.includes("localhost");
};

const navColor = () => {
  if (isDev()) {
    return "#89b6ff";
  } else if (window.location.origin.includes("staging")) {
    return "#f78585";
  }
  return "#ffffff";
};

//
// components
//
type EnvironmentProps = { children: ReactNode };
export const Environment = ({ children }: EnvironmentProps) => {
  const conf: EnvironmentConfig = {
    devMode: isDev(),
    navColor: navColor(),
  };
  return <HivewatchTheme conf={conf} children={children} />;
};

export const EnvironmentContext = React.createContext<CombinedConfig>(
  {} as any,
);

export const affiliations = {
  1: "HiveWatch",
};
